import Cookie from '~/shared/utils/Cookie';
import COUNTRY_CODE from './COUNTRY_CODE';
import inOneDay from '../utils/date/inOneDay';

const CountryCodeCookie = {
  get: (options?: CookieOptions) => Cookie.get(COUNTRY_CODE, options),
  set: (value: unknown, options?: Omit<CookieOptions, 'expires'>) =>
    Cookie.set(COUNTRY_CODE, value, { ...options, expires: inOneDay() }),
};

export default CountryCodeCookie;
